import { createAction, props } from '@ngrx/store';
import { ProjektDaten } from '../../components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';

export const loadPartProjektStart = createAction('ZEIT::PART_PROJECT_LOAD_START', props<{ item: ProjektDaten }>());
export const loadPartProjektSucceeded = createAction(
  'ZEIT::PART_PROJECT_LOAD_SUCCEEDED',
  props<{ partProjektDaten: ProjektDaten[] }>(),
);
export const loadPartProjektFailed = createAction('ZEIT::PART_PROJECT_LOAD_FAILED');
